import React, { Component } from 'react';
import {connect } from 'react-redux';
import {getMainData,addUser} from "../../Redux/ducks/mainReducer";
import {Alert,Label,Row,Col,FormGroup,Input, Button,Spinner,Table,Modal,
    ModalBody, ModalFooter,ModalHeader} from 'reactstrap'
import {checkRight,getName2} from "../../GeneralFunctions/general"
import ReactJsAlert from "reactjs-alert"
export class AddProcessingFee extends Component {
    state={
        isSaving:false,
        isSaving2:false,
        mainData:null,
        msg:null,
        addCatMsg:null,
        btnDisabled:false,
        errorMsg:null,
        successMsg:null,
        isLoading:true,
        alertStatus :false, alertType :"error", alertTitle:null,
        max:"",min:"",newClient:"",oldClient:"",selectedID:"",modal:false,
        status:"",statusList:[],min1:"",max1:"",oldClient1:"",newClient1:"",date1:"",updatedBy1:"",

    }

    componentDidMount(){
        /**refresh categories */
        this.props.getMainData("PROCESSFEE")
    }

    componentDidUpdate(prevProps){
        const{mainData,msg,mainDataStatus,addUserStatus} = this.props;
        
        if(mainDataStatus !== prevProps.mainDataStatus){
            if(mainDataStatus===true){
                this.setState({isSaving:false,mainData:mainData,isLoading:false})
            }else if(mainDataStatus===false){
                this.setState({isSaving:false,isLoading:false})
            }
        } 

        if(addUserStatus !== prevProps.addUserStatus){
            if(addUserStatus===true){
                this.setState({isSaving:false,isSaving2:false,successMsg:msg,btnDisabled:false,alertStatus :true, alertType :"success", alertTitle:msg})

                /**refresh categories */
                this.props.getMainData("PROCESSFEE")
            }else if(addUserStatus===false){
                this.setState({isSaving:false,isSaving2:false,erroMsg:msg,btnDisabled:false,
                    alertStatus :true, alertType :"error", alertTitle:msg})
            }
        } 
    }

    setValue = e =>{
        this.setState({[e.target.name]:e.target.value})
    }

    /**add new user*/
    addCategory =(e)=>{
        if(checkRight(11)===false){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Unauthorized to perform this action"})
        }else{
            const {min,max,newClient,oldClient} = this.state;

            if(min===""||max===""||newClient===""||oldClient===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Fill in all feilds marked with a *"})
            }else if(parseInt(min)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Minimum amount must not be less than zero"})
            }else if(parseInt(max)<1){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Minimum amount must not be less than one"})
            }else if(parseInt(min)>=parseInt(max)){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Maximum amount must not be greater than minimum amount"})
            }else if(parseInt(newClient)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"New Client Fee must not be less than zero"})
            }else if(parseInt(oldClient)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Old Client Fee must not be less than zero"})
            }else{
                this.setState({erroMsg:null,isSaving:true,btnDisabled:true,successMsg:null})
                const data = new FormData();
                data.append("min",min);
                data.append("max",max);
                data.append("newClient",newClient);
                data.append("oldClient",oldClient);
        
                /**upload new user*/
                this.props.addUser(data,"ADD_PROCESSFEE")
            }
        }
    }

    viewUser=(e)=>{
  
        const selectedID = e.target.id;
        this.setState({modal:true,selectedID:selectedID})
        const myUserData =  this.state.mainData.processingFeeData
        let catList =[]
        myUserData.map((values, i) =>{
            if(parseInt(values.id) ===parseInt(selectedID)){
                if(parseInt(values.status)===1){
                    catList.push(<option key={i} value={values.status}>{"Active"}</option>)
                    catList.push(<option value={0}>{"Innactive"}</option>)
                }else{
                    catList.push(<option key={i} value={values.status}>{"Innactive"}</option>)
                    catList.push(<option value={1}>{"Active"}</option>)
                }

               
                this.setState({
                    status:values.status,
                    statusList:catList,
                    min1:values.min,
                    max1:values.max,
                    oldClient1:values.amountOldClient,
                    newClient1:values.amount,
                    date1:values.updated_at,
                    updatedBy1:values.addedBy,
                })

            }
        });  
    }

    closeModal = ()=>{
        this.props.getMainData("PROCESSFEE")
        this.setState({modal:false})
    }

    changeFee=(e)=>{
        if(checkRight(12)===false){
            this.setState({  alertStatus :true, alertType :"error", alertTitle:"Unauthorized to perform this action"})
        }else{
            const {min1,max1,newClient1,oldClient1,status,selectedID} = this.state;
            if(min1===""||max1===""||newClient1===""||oldClient1===""){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Fill in all feilds marked with a *"})
            }else if(parseInt(min1)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Minimum amount must not be less than zero"})
            }else if(parseInt(max1)<1){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Minimum amount must not be less than one"})
            }else if(parseInt(min1)>=parseInt(max1)){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Maximum amount must not be greater than minimum amount"})
            }else if(parseInt(newClient1)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"New Client Fee must not be less than zero"})
            }else if(parseInt(oldClient1)<0){
                this.setState({  alertStatus :true, alertType :"error", alertTitle:"Old Client Fee must not be less than zero"})
            }else{
                this.setState({isSaving2:true})
                const data = new FormData();
                data.append("updateID",selectedID);
                data.append("status",status);
                data.append("min",min1);
                data.append("max",max1);
                data.append("newClient",newClient1);
                data.append("oldClient",oldClient1);
    
                this.props.addUser(data,"UPDATE_PROCESSFEE")
            }
        }
    }

    render() {
        
        let expenseCatDataList = [];
        const myUserData =  this.state.mainData
        var no =0
        if(myUserData !==null){
            if(myUserData.processingFeeData.length>0){
                myUserData.processingFeeData.map((values, i) =>{
                    no = no+1
                    expenseCatDataList.push(
                        <tr key={i}>

                            <th scope="row">{no}</th>
                            <td>{parseInt(values.min).toLocaleString()}</td>
                            <td>{parseInt(values.max).toLocaleString()}</td>
                            <td>{parseInt(values.amount).toLocaleString()}</td>
                            <td>{parseInt(values.amountOldClient).toLocaleString()}</td>
                           
                            {parseInt(values.status) ===1?<td><Label className="status1">Active</Label></td>:
                            <td><Label className="status2">Inactive</Label></td>
                            } 
                            <td>{getName2(myUserData.staffData,values.addedBy,"STAFF")}</td>
                            <td>{values.updated_at}</td>
                            <td><Button id={values.id} onClick={this.viewUser}>Edit</Button></td>
                        </tr>
                    )
                });
            }else{
                expenseCatDataList.push(
                    <div>
                        <br/><Alert color="primary">No processing fee ranges added yet</Alert>
                    </div>
                )
            }
        }
        return (
            <div>
                <div className="container">
                    <div className="block-header">
                    <h4>ADD PROCESSING FEE</h4>
                    </div>
                    <Row className="mainWrraper">
                        <ReactJsAlert autoCloseIn ={600000} status={this.state.alertStatus} type={this.state.alertType} title={this.state.alertTitle} Close={() => this.setState({ alertStatus: false })}/>
                        {this.state.modal ? 
                        <Modal  isOpen={this.state.modal} className="modalWrapper modal-dialog modal-lg">
                            <ModalHeader toggle={this.closeModal}>Update Processing Fee</ModalHeader>
                            <ModalBody className="modalBodyWrapper">
                                <Col xs="12" >
                                <FormGroup>
                                    <Label for="username">Minimum Amount(From)*</Label>
                                    <Input type="number" min="0" onChange={this.setValue} value={this.state.min1} name="min1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Maximum Amount(To)*</Label>
                                    <Input type="number" min="1" onChange={this.setValue} value={this.state.max1} name="max1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">New Client Fee*</Label>
                                    <Input type="number" min="1" onChange={this.setValue} value={this.state.newClient1} name="newClient1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Old Client Fee*</Label>
                                    <Input type="number" min="1" onChange={this.setValue} value={this.state.oldClient1} name="oldClient1" />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Updated By</Label>
                                    <Input type="text"  disabled  value={getName2(this.state.mainData.staffData,this.state.updatedBy1,"STAFF")} />
                                </FormGroup>

                                <FormGroup>
                                    <Label for="username">Updated At</Label>
                                    <Input type="text" disabled   value={this.state.date1}/>
                                </FormGroup>
                                

                                <FormGroup>
                                    <Label for="gender">Select Status</Label>
                                    <Input type="select" onChange={this.setValue} name="status">
                                        {this.state.statusList}
                                    </Input>
                                </FormGroup>

                                </Col>
                            
                    
                                <Col xs="12" >
                                    {this.state.isSaving2?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Updating...'}</div>:null}
                                    <Button onClick={this.changeFee} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Update Processing Fee</Button>
                                </Col>
                            </ModalBody>
                        </Modal>
                        :null}
                        
                        
                        
                        
                        <Col xs="12" md="3">
                            <FormGroup>
                                <Label for="username">Minimum Amount(From)*</Label>
                                <Input type="number" min="0" onChange={this.setValue} value={this.state.cdate} name="min" />
                            </FormGroup>
                        </Col>
                        <Col xs="12" md="3">
                            <FormGroup>
                                <Label for="username">Maximum Amount(To)*</Label>
                                <Input type="number" min="1" onChange={this.setValue} value={this.state.cdate} name="max" />
                            </FormGroup>
                        </Col>
                        <Col xs="12" md="3">
                            <FormGroup>
                                <Label for="username">New Client Fee*</Label>
                                <Input type="number" min="1" onChange={this.setValue} value={this.state.cdate} name="newClient" />
                            </FormGroup>
                        </Col>
                        <Col xs="12" md="3">
                            <FormGroup>
                                <Label for="username">Old Client Fee*</Label>
                                <Input type="number" min="1" onChange={this.setValue} value={this.state.cdate} name="oldClient" />
                            </FormGroup>
                        </Col>
                  
                        <Col xs="12" >
                        
                            {this.state.isSaving?<div><Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Saving...'}</div>:null}
        
                            <Button onClick={this.addCategory} disabled={this.state.btnDisabled? "disabled":null} className="btn btn-block btn-lg btn-danger">Add Processing Fee</Button>
                        </Col>

                       

                        <Col xs="12" md="12" className="tableWrapper">
                            <div className="table-container">
                                <Table striped responsive>
                                    <thead>
                                        <tr>
                                            <th>No</th>
                                            <th>From</th>
                                            <th>To</th>
                                            <th>P Fee (New Client)</th>
                                            <th>P Fee (Old Client)</th>
                                            <th>Status</th>
                                            <th>Updated By</th>
                                            <th>Updated At</th>
                                        
                                            <th>Edit</th>
                                        </tr>
                                    </thead>
                                    {this.state.isLoading?
                                    <tbody>
                                        <tr>
                                            <td colSpan="8">
                                                <Spinner className="mySpinner" /><Spinner className="mySpinner" type="grow"/>{'Loading...'}
                                            </td>
                                        </tr>
                                    </tbody>:
                                    
                                    <tbody>
                                        {expenseCatDataList}
                                    </tbody>}
                                </Table>
                            </div>

                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state =>({
    mainDataStatus : state.mainReducer.dataStatus,
    msg : state.mainReducer.msg,
    mainData : state.mainReducer.mainData,
    addUserStatus:state.mainReducer.addUserStatus,
});
export default connect(
    mapStateToProps, {getMainData,addUser}
)(AddProcessingFee)
